import { color } from "@repo/fika-design-system/color"
import { transitionMid } from "@repo/fika-design-system/transition"
import { createMemo, mergeProps } from "solid-js"
import { Dynamic } from "solid-js/web"
import {
  baseSvgClass,
  fikaLogoClass,
  hatColorVar,
  headColorVar,
} from "./fika-logo.css"

interface FikaLogoProps {
  withText?: boolean
  link?: boolean
}

export function FikaLogo(incomingProps: FikaLogoProps) {
  const props = mergeProps({ withText: false, link: false }, incomingProps)
  const svgWidth = createMemo(() => (props.withText ? 347 : 92))

  return (
    <Dynamic
      component={props.link ? "a" : "span"}
      href={props.link ? "/" : undefined}
      class={fikaLogoClass}
    >
      <svg
        viewBox={`0 0 ${svgWidth()} 92`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class={baseSvgClass}
      >
        <LogoPaths showText={props.withText} />
      </svg>
    </Dynamic>
  )
}

const fillTransition = transitionMid(["fill"])

function LogoPaths(props: { showText: boolean }) {
  return (
    <>
      {props.showText && (
        <g fill={color.emerald900}>
          <path d="M182.099 8.746c10.66 0 15.197 2.724 15.197 13.17 0 8.401-7.575 12.262-15.197 12.262-10.207 0-15.114-3.407-15.424-12.262-.278-7.921 4.763-13.17 15.424-13.17" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M283.716 10.79v25.204s12.022-1.038 19.734-1.59c9.526-.68 16.785 0 16.785 7.267 0 0-19.054 0-28.807 2.044-8.392 1.758-16.204 8.866-15.651 22.252 0 0 0 17.258 17.919 17.94 0 0 14.29 2.043 29.261-12.944 1.587 6.358 2.495 10.9 2.495 10.9H347s-.68-23.616-1.134-43.825c0 0 1.814-28.149-29.941-29.292-12.929-.466-32.209 2.043-32.209 2.043M320.688 58.7v-8.855s-8.392.908-14.97 1.589c-3.125.324-6.124.454-6.124 5.223 0 1.362.907 5.975 10.207 4.995 4.309-.454 10.887-2.952 10.887-2.952"
          />
          <path d="M201.152 8.746h26.992v22.253l.454 9.764 15.877-32.017h32.89v.68l-23.59 33.607 25.405 38.148.226.909-33.343-.228-17.465-35.877 1.134 35.878h-27.673V21.688zM169.17 81.863h27.672l-1.588-24.751V35.994h-26.992l.908 17.712zm-20.188-.001H121.99l.227-23.388H117V33.95h5.897s-2.948-31.109 36.066-25.205V29.41s-6.805-1.362-9.073 0c-2.949 1.77-2.042 4.541-2.042 4.541l11.115-.454v24.978h-10.661z" />
        </g>
      )}
      <path
        d="M46.363 0v.037c.312.061.62.199.916.383.414.256.84.623 1.276 1.075.873.903 1.822 2.187 2.813 3.723 1.986 3.076 4.175 7.216 6.295 11.481 2.12 4.267 4.177 8.673 5.897 12.28 1.728 3.622 3.104 6.41 3.868 7.48.314.438.918.962 1.77 1.558.847.592 1.912 1.236 3.122 1.92 2.423 1.37 5.389 2.877 8.289 4.415 2.89 1.534 5.714 3.097 7.816 4.565 1.05.734 1.935 1.453 2.559 2.142.619.682 1.016 1.372 1.016 2.04v.312c0 12.24-92 9.458-92 0v-.312c0-.668.398-1.357 1.016-2.04.624-.689 1.508-1.408 2.559-2.142 2.102-1.468 4.925-3.031 7.816-4.565 2.9-1.538 5.866-3.045 8.289-4.415 1.21-.684 2.275-1.328 3.121-1.92.853-.596 1.457-1.12 1.77-1.559.765-1.07 2.14-3.857 3.869-7.48 1.72-3.606 3.777-8.012 5.897-12.279 2.12-4.265 4.309-8.405 6.294-11.48.992-1.537 1.941-2.82 2.814-3.724.436-.452.862-.819 1.276-1.075.297-.184.604-.322.916-.383V0z"
        style={{ fill: hatColorVar, transition: fillTransition }}
      />
      <path
        d="M20.04 65.658c15.38 3.237 36.518 3.508 51.902.466C71.37 79.96 59.976 92 46 92c-14.132 0-25.627-12.29-25.96-26.342"
        style={{ fill: headColorVar, transition: fillTransition }}
      />
    </>
  )
}
